export interface PaginationRequest {
  page: number;
  pageSize: number;
}

export const createPaginationRequest = (page: number = 1, pageSize: number = 10): PaginationRequest => ({
  page,
  pageSize,
});
